import '../sass/main.scss'
import setFrontPage from './libs/handleFrontPage.js'

setFrontPage()
